// -----------------------------------------------------------------------------
// <copyright file="loader.module.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { LoaderComponent } from './loader.component';

@NgModule({
	declarations: [LoaderComponent],
	imports: [CommonModule, FormsModule],
	exports: [LoaderComponent],
	providers: [],
})
export class LoaderModule {}
